import cn from 'classnames';

type ProductPriceDefaultProps = {
    className?: string;
    originalPrice?: string;
    price: string;
};

export function ProductPriceDefault({ className, originalPrice, price }: Readonly<ProductPriceDefaultProps>) {
    const screenReaderText = originalPrice
        ? `Sale price ${price} original price ${originalPrice}`
        : `Price is ${price}`;

    return (
        <div className={cn('sparky-c-price', className, { 'sparky-c-price__strike-group': originalPrice })}>
            <span className="visually-hidden">{screenReaderText}</span>
            {originalPrice ? (
                <div className="sparky-c-price--data">
                    <span aria-hidden="true" className="sparky-c-price--sale">
                        {price}
                    </span>
                    <span aria-hidden="true" className="sparky-c-price--disabled">
                        {originalPrice}
                    </span>
                </div>
            ) : (
                <span aria-hidden="true" className="sparky-c-price">
                    {price}
                </span>
            )}
        </div>
    );
}
